export default __webpack_public_path__ + "static/media/compliance-2024.555968fb.jpg";